"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.repeater = exports.repeat = void 0;
/**
 * Executes or "repeats" a function some number of times.
 * @returns The output of each call in order of its execution
 */
function repeat(numberOfTimes, callee) {
    const calleeReturnValues = [];
    const normalizedNumberOfTimes = Math.round(numberOfTimes);
    for (let i = 0; i < normalizedNumberOfTimes; i++) {
        calleeReturnValues.push(callee(i));
    }
    return calleeReturnValues;
}
exports.repeat = repeat;
/**
 * Creates a "repeater" function that will execute its function-argument some number of times.
 * @see repeat
 */
function repeater(numberOfTimes) {
    // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
    return (callee) => repeat(numberOfTimes, callee);
}
exports.repeater = repeater;
//# sourceMappingURL=repeat.js.map